/**
 * Geometry of the extraction-review dialog.
 *
 * Fill nearly the whole viewport on small screens (little wasted margin), then
 * cap the size on large screens via max-w/max-h. The base DialogContent bakes
 * in `flex-col`, `w-max` and `sm:max-w-lg`; tailwind-merge only replaces
 * classes within the same group AND variant, so layout/width must be
 * overridden in-kind (`flex-row` beats `flex-col`, `sm:max-w-*` beats
 * `sm:max-w-lg`) or the dialog collapses into a 512px column.
 *
 * Lives apart from the panel so the lazy wrapper's loading state can size its
 * placeholder card identically without importing the panel (and with it
 * pdfjs). The size is known before the chunk arrives, so the card should open
 * at its final size and fill in, rather than resize under the reviewer.
 */
export const EXTRACTION_DIALOG_CLASS =
  "h-[95svh] max-h-[900px] w-[95vw] flex-row gap-4 sm:max-w-[1400px]";
